/** New identities always select a plan; an existing selection survives every entry path. */
export function signupPlanPath(returnPath:string|undefined,basePath=''):string {
 const target=new URL(returnPath??`${basePath}/subscribe`,'https://local.invalid');
 const next=target.searchParams.get('next');
 const selected=target.searchParams.get('plan')??(next?new URL(next,'https://local.invalid').searchParams.get('plan'):null);
 const query=new URLSearchParams({new_signup:'1'});
 if(selected&&/^[0-9a-f-]{36}$/i.test(selected))query.set('plan',selected);
 return `${basePath}/subscribe?${query}`;
}
